import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleDownSmall"><Path d="M15 11H9L12 14.5L15 11Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
